<template>
  <div>
    <new-dialog v-if="dialogVisible" destroyOnClose width="540px" title="分享店铺产品" :visible.sync="dialogVisible" :show-head="true" :show-footer="false" :show-close="true" :close-on-click-modal="false" @cancelFun="cancelFun">
      <template #default>
        <div class="share-product">
          <p class="share-product-title">
            <i class="ficon ficon-tanhao"></i>产品对外分享仅展示零售价，并只展示您店铺的信息及联系方式，不会露出任何关于平台的元素。
          </p>
          <h3 class="text-base">分享链接</h3>
          <div class="share-product-info">
            <el-input v-model="shareData.page" class="share-product-info-content"></el-input>
            <el-button class="copy-btn" type="primary" size="small" v-clipboard="copyContent" v-clipboard:success="handleCopySuccess" v-clipboard:error="handleCopyError">复制</el-button>
          </div>
          <h3 class="text-base">分享二维码</h3>
          <div class="share-product-qrcode">
            <div v-if="isOpenShop" class="qrcode-box">
              <p class="qrcode-box-title">店铺首页</p>
              <el-image class="img" :src="shareData.qr_index" fit="cover" lazy />
              <el-button v-if="shareData.qr_index != ''" type="primary" @click="handleDownload(shareData.qr_index, '店铺首页')">保存图片</el-button>
            </div>
            <!--    产品列表" / "产品详情" -->
            <template>
              <div class="qrcode-box" v-if='name == "产品列表"'>
                <p class="qrcode-box-title">产品列表</p>
                <el-image class="img" :src="shareData.qr_page" fit="cover" lazy />
                <el-button v-if="shareData.qr_page != ''" type="primary" @click="handleDownload(shareData.qr_page, name)">保存图片</el-button>
              </div>
              <div class="qrcode-box" v-else>
                <p class="qrcode-box-title">产品详情</p>
                <PosterShop :loading.sync="loadingPoster" ref="refPosterShop" :data="posterShopData" />
                <el-button :disabled="loadingPoster" :loading="loadingPoster" type="primary" @click="donwloadShopPoster">{{loadingPoster ? '加载中...' : '保存图片'}}</el-button>
              </div>
            </template>
          </div>
        </div>
      </template>
    </new-dialog>
    <!--店铺信息不完善-->
    <shop-tips destroyOnClose width="400px" title="提示" :show-cancel="false" :submitText="submitText" :visible.sync="showShopVisible" @submitFun="handleSubmitFun">
      <template #default>
        <div class="tips" v-html="msg"></div>
      </template>
    </shop-tips>
  </div>
</template>

<script>
import { defineComponent} from '@nuxtjs/composition-api';

// api
import NewDialog from "@/components/NewDialog/Main";
import shopTips from "@/views/product/components/shopTips";
import PosterShop from "@/views/product/components/ShareShopProduct/PosterShop.vue";

import { getProductShare, shareReportData } from "~/services/product";

import { pick } from "@/utils/helpers";
import DownloadByUrl from "@/utils/file-download";

import clipboard from "@/directives/clipboard";

export default defineComponent({
  name: "ShareProduct",
  directives: { clipboard },
  components: { NewDialog, shopTips, PosterShop },
  data() {
    return {
      dialogVisible: false, //分享店铺产品成功
      showShopVisible: false, //去完善店铺
      product_no: "",
      name: "",
      shareData: {
        page: "",
        qr_index: "",
        qr_page: "",
        shop_name: "",
      },
      code: 1000,
      msg: "", //提示信息
      submitText: "去完善",
      posterShopData: {
        productName: "",
        productImg: "",
        productPosterBg: "",
        minPrice: "",
        shop_name: "",
        url: "",
        shop_avatar: "",
      },
      loadingPoster: true,
    };
  },
  computed: {
    isOpenShop() {
      return this.$store.getters.isOpenShop;
    },
    sharing_code(){
      return this.$auth.$state.user.sharing_code
    }
  },
  methods: {
    async handleShareShopPrdouct(data) {
      Object.assign(this, pick(data, ["product_no", "name"]));
      if (data.title) {
        this.name = data.title;
      }
      this.getShareShopProduct();
    },
    async getShareShopProduct() {
      let { code, msg, data } = await getProductShare({
        product_no: this.product_no,
      });
      let submitText = "";
      switch (code) {
        case 10000:
          this.dialogVisible = true;
          Object.assign(this.shareData, data);

          this.posterShopData = {
            productName: data.product_name,
            productImg: data.image,
            productPosterBg: data.image,
            min_price: data.min_price,
            shop_name: data.shop_name,
            shop_head_url: data.shop_head_url,
            qrcode_url: data.qr_page,
          };
          break;
        case 10901:
          this.showShopVisible = true;
          msg = "因为是首次分享店铺产品，请先完善您的店铺信息。便于用户在产看产品的同时了解您的公司，建立双方的信任。";
          submitText = "去完善";
          break;
        case 10902:
          this.showShopVisible = true;
          msg = msg.replace(/%&/g, "<em>").replace(/&%/g, "</em>");
          submitText = "知道了";
          break;
        default:
          this.$message.error(msg);
      }
      Object.assign(this, { submitText, msg, code });
    },
    cancelFun() {
      this.dialogVisible = false;
    },
    copyContent() {
      return this.name != "产品列表"
        ? this.name + " " + this.shareData.page
        : this.shareData.shop_name + " " + this.shareData.page;
    },
    handleCopySuccess() {
      this.$message.success("复制成功");
      //加埋点
      shareReportData(
        {
          type:2,
          report_type:4,
          rel_id:this.product_no,
          sharing_code:this.sharing_code
        }
      )
    },
    handleCopyError() {
      this.$message.error("复制失败");
    },
    handleDownload(url, name) {
      name = name + ".png";
      DownloadByUrl(url, name);

      //加埋点
      if(name === '店铺首页.png'){
        shareReportData(
          {
            type:4,
            report_type:3,
            rel_id:this.shareData.page_index,
            sharing_code:this.sharing_code
          }
        )
      } else {
        shareReportData(
          {
            type:9,
            report_type:3,
            rel_id:this.shareData.page,
            sharing_code:this.sharing_code
          }
        )
      }
    },
    //关闭提示 店铺信息不完善
    handleSubmitFun() {
      if (this.code === 10901) {
        // window.location.href = "/user/shop/productmanagement";
        window.open('/designer', '_blank')
      }
      this.showShopVisible = false;
    },
    donwloadShopPoster() {
      if (this.loadingPoster) return
      this.$refs.refPosterShop.download()
      //加埋点
      shareReportData(
        {
          type:2,
          report_type:1,
          rel_id:this.product_no,
          sharing_code:this.sharing_code
        }
      )
    },
  },
});
</script>

<style lang="scss" scoped>

::v-deep .new-dailog {
  .el-dialog__header {
    border-bottom: 1px solid rgba(244, 244, 246, 0.58);
  }
  .el-dialog__title {
    color: $color-grey-14;
  }
}
::v-deep .share-product {
  width: 100%;
  box-sizing: border-box;
  h3 {
    font-weight: 500;
    color: $color-grey-14;
    margin: 12px 0 12px;
  }
  &-title {
    background: $color-yellow-2;
    color: #CC4B0C;
    font-weight: 400;
    padding: 10px;
    // border: 1px solid $color-orange;
    box-sizing: border-box;
    border-radius: 2px;
    margin: 0px 0 15px 0;
    .ficon {
      font-size: 16px;
      margin-right: 5px;
    }
  }
  &-info {
    // margin: 37px 0;
    display: flex;
    margin-bottom: 16px;
    &-content {
      width: 450px;
      //padding: 12px;
      box-sizing: border-box;
      margin-right: 10px;
      .el-input__inner {
        color: $color-grey-16;
        font-size: 14px;
        font-weight: 400;
        height: 32px;
        border-radius: 2px;
        background: $color-white-1;
        border: 0;
      }
    }
    .copy-btn {
      width: 69px;
    }
  }
  &-qrcode {
    // width: 625px;
    padding: 0 60px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .qrcode-box {
      text-align: center;
      display: flex;
      flex-direction: column;

      & + .qrcode-box {
        margin-left: 50px;
      }
      &-title {
        color: $color-grey-14;
        font-weight: 400;
        margin-bottom: 8px;
        text-align: left;
      }
      .el-image {
        width: 144px;
        height: 144px;
        border-radius: 2px;
        overflow: hidden;
      }
      .el-button {
        margin: 8px auto 0;
      }

      // .el-button {
      //   width: 144px;
      //   // height: 32px;
      //   border: 1px solid $color-black-1;
      //   color: $color-grey-14;
      //   font-size: 16px;
      //   font-weight: normal;
      // }
      // .el-button:hover {
      //   color: $color-orange;
      //   border-color: $color-orange;
      // }
    }
  }
}
.loading {
  min-height: 260px;
}

</style>
